import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Link} from 'react-router-dom';
import {Breadcrumb,} from 'semantic-ui-react';

import CustomDivider from '../../components/extras/CustomDivider';
import TaxData from "../../data/TaxData";
import QuestionDialog from "../../components/extras/QuestionDialog";
import CheckPermission from "../../components/extras/CheckPermission";
import DynamicTable from "../../components/extras/DynamicTable";
import {dynamicTableAddOrUpdate, dynamicTableDelete} from "../../actions/DynamicTableDataAction";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {taxDialog} from "../../actions/TaxDialogAction";

class Taxes extends Component {
    constructor() {
        super();
        this.state = {
            table: {
                headers: ['Impuesto', 'Porcentaje', 'Acciones'],
                name: 'Impuesto',
                title: 'Impuestos',
                has_actions: true,
                edit: true,
                can_add: true,
                pagination: true,
                delete: true,
                url: 'taxes',
                values: ['id', 'name', 'percentage', 'active'],
                percentage_fields: ['percentage'],
                id: 'table_taxes'
            }
        };
        this.delete = this.delete.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.tax_select && nextProps.tax_select.hasOwnProperty('id')){
            this.props.dynamicTableAddOrUpdate(nextProps.tax_select);
        }
    }

    callbackDynamicTable = (response) => {
        if(response.event === 'add'){
            this.props.taxDialog({open:true, tax:{id:null}});
        }else if(response.event === 'edit'){
            this.props.taxDialog({open:true, tax:response.data});
        }else if(response.event === 'delete'){
            this.refs.deleteDialog.open('', response.data.id);
        }
    };

    async delete(id) {
        TaxData.delete(id, (res) => {
            if (res.delete) {
                this.props.showToast({message: 'Impuesto borrado!', type: 'success'});
                this.props.dynamicTableDelete(id);
            } else {
                this.refs.toast.show({message: 'Tenemos un problema!', type: 'error'});
            }
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Impuestos | Configuraciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider/>
                    <Breadcrumb.Section active>Impuestos</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <DynamicTable {...this.state.table} callbackDynamicTable={this.callbackDynamicTable}/>
                <QuestionDialog ref="deleteDialog" message="Borrar este impuesto" callbackConfirm={this.delete}/>
                <CheckPermission access='taxes_view'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        tax_select: state.get('tax_select'),
    };
}

function mapDispatchToProps(dispatch){
    return {
        dynamicTableAddOrUpdate(data){
            dispatch(dynamicTableAddOrUpdate(data))
        },
        dynamicTableDelete(data){
            dispatch(dynamicTableDelete(data))
        },
        showToast(data){
            dispatch(showToast(data))
        },
        taxDialog(data) {
            dispatch(taxDialog(data));
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Taxes)


// WEBPACK FOOTER //
// ./src/containers/settings/Taxes.js